import { PackageSecurityServerAssignmentGridWebComponent } from './component/PackageSecurityServerAssignmentGridWebComponent';
import { WEB_COMPONENT_PACKAGE_SECURITY_SERVER_ASSIGNMENT_GRID } from '../../../webcomponents.constants';

export { PackageSecurityServerAssignmentGridWebComponent };

window.customElements.define(
  WEB_COMPONENT_PACKAGE_SECURITY_SERVER_ASSIGNMENT_GRID,
  PackageSecurityServerAssignmentGridWebComponent
);
